module.exports = __webpack_public_path__ + "img/resultados-q2-2023-oficial.9bf14bb6.jpg";